(function () {
  if (window.__wipesLimitLoaded) return;
  window.__wipesLimitLoaded = true;

  const LIMITED = [54625700905144, 54625726365880, 54626572894392, 54626572927160];
  const MSG = 'The ₹1 Sunscreen Wipes offer is limited to 1 pack per customer. You can choose either Vitamin E or Cucumber.';
  const isLimited = (id) => LIMITED.includes(Number(id));
  const nativeFetch = window.fetch.bind(window);

  function toast(msg) {
    if (!document.body) return;
    const el = document.createElement('div');
    el.textContent = msg;
    el.style.cssText = 'position:fixed;left:50%;top:16px;transform:translateX(-50%);background:#5b2d91;color:#fff;padding:12px 18px;border-radius:8px;z-index:2147483647;font-size:14px;max-width:90%;text-align:center';
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 4000);
  }

  async function getCart() {
    const r = await nativeFetch('/cart.js?t=' + Date.now(), {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    return r.json();
  }

  const limitedQty = (cart) =>
    cart.items.filter((i) => isLimited(i.variant_id)).reduce((s, i) => s + i.quantity, 0);

  function linesFromEntries(entries) {
    const lines = [];
    let id = null, q = 1;
    const items = {};
    for (const [k, v] of entries) {
      if (k === 'id') id = v;
      else if (k === 'quantity') q = Number(v) || 1;
      else {
        const m = String(k).match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        if (m) {
          items[m[1]] = items[m[1]] || {};
          items[m[1]][m[2]] = v;
        }
      }
    }
    if (id) lines.push({ id, qty: q });
    Object.values(items).forEach((i) => {
      if (i.id) lines.push({ id: i.id, qty: Number(i.quantity) || 1 });
    });
    return lines;
  }

  function linesFromBody(body) {
    try {
      if (body instanceof FormData) return linesFromEntries(body.entries());
      if (body instanceof URLSearchParams) return linesFromEntries(body.entries());
      if (typeof body === 'string') {
        if (body.trim().startsWith('{')) {
          const j = JSON.parse(body);
          const lines = [];
          if (j.id) lines.push({ id: j.id, qty: Number(j.quantity) || 1 });
          (j.items || []).forEach((i) => lines.push({ id: i.id, qty: Number(i.quantity) || 1 }));
          return lines;
        }
        return linesFromEntries(new URLSearchParams(body).entries());
      }
    } catch (e) {}
    return [];
  }

  async function wouldBreakLimit(lines) {
    const add = lines.filter((l) => isLimited(l.id));
    if (!add.length) return false;
    const addQty = add.reduce((s, l) => s + l.qty, 0);
    if (addQty > 1) return true;
    const cart = await getCart();
    return limitedQty(cart) + addQty > 1;
  }


  // Clamp quantity changes (cart drawer + / cart page) BEFORE they are sent
  const CHANGE_RE = /\/cart\/(change|update)(\.js)?(\?|$)/;
  async function clampCartBody(url, body) {
    if (typeof body !== 'string') return { body, changed: false };
    const isJson = body.trim().startsWith('{');
    let data;
    try {
      data = isJson ? JSON.parse(body) : Object.fromEntries(new URLSearchParams(body).entries());
    } catch (e) { return { body, changed: false }; }
    let changed = false;
    let cart = null;
    const byLine = async (n) => {
      cart = cart || (await getCart());
      const it = cart.items[Number(n) - 1];
      return it && it.variant_id;
    };
    const byKey = (k) => parseInt(String(k).split(':')[0], 10);
    try {
      if (/\/cart\/change/.test(url)) {
        if (data.quantity !== undefined && Number(data.quantity) > 1) {
          const vid = data.line !== undefined ? await byLine(data.line) : byKey(data.id);
          if (vid && isLimited(vid)) { data.quantity = isJson ? 1 : '1'; changed = true; }
        }
      } else if (isJson && data.updates && typeof data.updates === 'object') {
        if (Array.isArray(data.updates)) {
          for (let i = 0; i < data.updates.length; i++) {
            if (Number(data.updates[i]) > 1) {
              const vid = await byLine(i + 1);
              if (vid && isLimited(vid)) { data.updates[i] = 1; changed = true; }
            }
          }
        } else {
          for (const k of Object.keys(data.updates)) {
            if (Number(data.updates[k]) > 1 && isLimited(byKey(k))) { data.updates[k] = 1; changed = true; }
          }
        }
      } else if (!isJson) {
        for (const k of Object.keys(data)) {
          const m = k.match(/^updates\[(.+)\]$/);
          if (m && Number(data[k]) > 1) {
            const vid = /^\d+$/.test(m[1]) && Number(m[1]) < 1000 ? await byLine(m[1]) : byKey(m[1]);
            if (vid && isLimited(vid)) { data[k] = '1'; changed = true; }
          }
        }
      }
    } catch (e) {}
    if (!changed) return { body, changed: false };
    return { body: isJson ? JSON.stringify(data) : new URLSearchParams(data).toString(), changed: true };
  }

  // 1) fetch-based add to cart
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : input && input.url;
    if (url && CHANGE_RE.test(url) && init && typeof init.body === 'string') {
      const r = await clampCartBody(url, init.body);
      if (r.changed) { toast(MSG); init = Object.assign({}, init, { body: r.body }); }
    }
    if (url && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      let body = init && init.body;
      if (!body && input && typeof input !== 'string' && input.clone) {
        try { body = await input.clone().text(); } catch (e) {}
      }
      const lines = linesFromBody(body);
      if (await wouldBreakLimit(lines)) {
        toast(MSG);
        return new Response(
          JSON.stringify({ status: 422, message: 'Limit reached', description: MSG }),
          { status: 422, headers: { 'Content-Type': 'application/json' } }
        );
      }
    }
    const res = await nativeFetch(input, init);
    if (url && /\/cart\/(add|change|update)/.test(url)) scheduleEnforce();
    return res;
  };

  // 2) XMLHttpRequest-based add to cart
  const nativeSend = XMLHttpRequest.prototype.send;
  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__wl_url = url;
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    const xhr = this;
    if (xhr.__wl_url && /\/cart\/add(\.js)?(\?|$)/.test(xhr.__wl_url)) {
      const lines = linesFromBody(body);
      if (lines.some((l) => isLimited(l.id))) {
        wouldBreakLimit(lines).then((blocked) => {
          if (blocked) { toast(MSG); xhr.abort(); }
          else nativeSend.call(xhr, body);
        });
        return;
      }
    }
    return nativeSend.call(xhr, body);
  };

  // 3) normal form submits, including Buy it now
  document.addEventListener(
    'submit',
    async function (e) {
      const form = e.target;
      if (!form || !form.action || !/\/cart\/add/.test(form.action)) return;
      if (form.__wlOk) { form.__wlOk = false; return; }
      const lines = linesFromEntries(new FormData(form).entries());
      if (!lines.some((l) => isLimited(l.id))) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (await wouldBreakLimit(lines)) { toast(MSG); return; }
      form.__wlOk = true;
      if (form.requestSubmit) form.requestSubmit(e.submitter || undefined);
      else form.submit();
    },
    true
  );

  // 4) clean up the cart if it is ever over the limit
  let enforcing = false;
  async function enforce() {
    if (enforcing) return;
    enforcing = true;
    try {
      const cart = await getCart();
      if (limitedQty(cart) <= 1) return;
      const lines = cart.items.filter((i) => isLimited(i.variant_id));
      const updates = {};
      lines.forEach((l, idx) => (updates[l.key] = idx === 0 ? 1 : 0));
      await nativeFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      toast(MSG);
      location.reload(); // refreshes the cart drawer too
    } catch (e) {
    } finally {
      enforcing = false;
    }
  }
  function scheduleEnforce() {
    [500, 1500, 3000].forEach((t) => setTimeout(enforce, t));
  }

  // 5) lock quantity boxes (also in the quick-view popup) to 1
  function formIsLimited(inp) {
    if (inp.dataset && inp.dataset.quantityVariantId) return isLimited(inp.dataset.quantityVariantId);
    const form = inp.form || inp.closest('form');
    if (!form) return false;
    const idEl = form.querySelector('[name="id"]');
    return !!idEl && isLimited(idEl.value);
  }
  function lockQty() {
    document
      .querySelectorAll('input[name="quantity"], input.quantity__input, input[type="number"]')
      .forEach((inp) => {
        if (!formIsLimited(inp)) return;
        inp.min = 1;
        inp.max = 1;
        if (Number(inp.value) !== 1) inp.value = 1;
        const wrap = inp.closest('quantity-input, .quantity, .product-form__quantity, .quantity-selector');
        if (wrap) {
          wrap.querySelectorAll('button').forEach((b) => {
            b.disabled = true;
            b.style.pointerEvents = 'none';
            b.style.opacity = '0.4';
          });
        }
      });
  }

  let t;
  const debouncedLock = () => { clearTimeout(t); t = setTimeout(lockQty, 80); };
  const startObserver = () =>
    new MutationObserver(debouncedLock).observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'class'],
    });
  if (document.documentElement) startObserver();

  // any click anywhere: re-check the cart a few times shortly after
  document.addEventListener('click', () => { lockQty(); scheduleEnforce(); }, true);
  document.addEventListener('input', debouncedLock, true);
  document.addEventListener('change', debouncedLock, true);

  // page load and Back button
  window.addEventListener('pageshow', () => { enforce(); lockQty(); });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') enforce();
  });
  document.addEventListener('DOMContentLoaded', () => { enforce(); lockQty(); });
})();